import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login/index.vue')
    },
    {
        path: '/',
        component: () => import('@/views/index.vue')
    },
    {
        path: '/articlexieyi',
        component: () => import('@/views/articlexieyi.vue')
    },
    {
        path: '/subject/index',
        component: () => import('@/views/subject/index.vue')
    },
    {
        path: '/subject/real',
        component: () => import('@/views/subject/real.vue')
    },
    {
        path: '/subject/middle',
        component: () => import('@/views/subject/middle.vue')
    },
    {
        path: '/article/detail',
        component: () => import('@/views/article/detail.vue')
    },
    {
        path: '/article/articledetail',
        component: () => import('@/views/article/articledetail.vue')
    },
    {
        path: '/icon/index',
        component: () => import('@/views/icon/iconindex.vue')
    },
    {
        path: '/category/delicate',
        component: () => import('@/views/category/vipdelicate.vue')
    },
    {
        path: '/category/special',
        component: () => import('@/views/category/vipspecial.vue')
    },
    {
        path: '/member/wrong',
        component: () => import('@/views/member/wrong.vue')
    },
    {
        path: '/member/order',
        component: () => import('@/views/member/order.vue')
    },
    {
        path: '/member/member',
        component: () => import('@/views/member/member.vue')
    },
    {
        path: '/sanli/index',
        component: () => import('@/views/sanli/index.vue')
    },
    {
        path: '/order/goods',
        component: () => import('@/views/order/goodsbox.vue')
    },
    {
        path: '/order/index',
        component: () => import('@/views/order/index.vue')
    },
    {
        path: '/user/index',
        component: () => import('@/views/user/user.vue')
    },
    {
        path: '/paper/detail',
        component: () => import('@/views/subject/paperdetail.vue')
    },
    {
        path: '/media/live',
        component: () => import('@/views/media/live.vue')
    },
];


const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})


const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
